import { createEffect, createEvent, createStore, sample } from 'effector';
import { $workspaces } from '@nx-frontend/shared/store/workspaces/workspaces';
import { Workspace } from '@nx-frontend/shared/types';

export const initialCurrentWorkspaceState: Workspace = {
  id: 0,
  globalId: '',
  orgId: '',
  userId: 0,
  createdAt: 0,
  updatedAt: 0,
  title: '',
  isDefault: false,
  defaultEncryptionKeyId: null,
  isNotesLimited: false,
  color: '',
  brandingProfileId: '',
  webClientBrandingProfileId: null,
  orgType: '',
  orgSubscriptionType: '',
  orgSubscriptionPrivileges: [],
};

export const $currentWorkspace = createStore<Workspace>(initialCurrentWorkspaceState);

export const setWorkspacesEvent = createEvent<Workspace>();

export const setWorkspaceByIdEvent = createEvent<string>();

$currentWorkspace.on(setWorkspacesEvent, (_, newWorkspace) => newWorkspace);

export const setWorkspaceFx = createEffect((workspace: Workspace) => {
  return workspace;
});

/**
 * When set workspace by id, need to find workspace in workspaces list
 */
sample({
  clock: setWorkspaceByIdEvent,
  source: [$workspaces, $currentWorkspace],
  fn: (source, workspaceId) => {
    const workspaces = source[0] as Workspace[];
    const currentWorkspace = source[1] as Workspace;
    return workspaces.find((workspace) => workspace.globalId === workspaceId) || currentWorkspace;
  },
  target: setWorkspaceFx,
});

$currentWorkspace.on(setWorkspaceFx.doneData, (_, workspace) => workspace);
